import { sendGTMEvent } from "@frend-digital/events/gtm";

interface TrackContentClickParams {
	contentType: string;
	itemId: string;
	href?: string;
	label?: string;
}

export function trackContentClick({ contentType, itemId, href, label }: TrackContentClickParams) {
	if (typeof window === "undefined") return;

	sendGTMEvent({
		event: "select_content",
		content_type: contentType,
		item_id: itemId,
		link_url: href,
		link_text: label,
		page_path: window.location.pathname,
	});
}
